export const MAINTENANCE_CONF = {
    title: 'Improvements Coming Soon!',
    message: "We're working to upgrade your experience! Our site is currently under maintenance and will be back online in 10-15 minutes. We appreciate your patience."
};